import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import store from "@/store";
import { useRoute, useRouter } from "vue-router/composables";
import useGetUserPlatform from "@/composables/use-get-user-platform";


export default /*#__PURE__*/_defineComponent({
  __name: 'enter-email-verification-code',
  setup(__props) {

const MAX_RESEND_WAIT_IN_SEC = 60;
const route = useRoute();
const router = useRouter();
const verificationCode = ref("");
const tryInSeconds = ref(MAX_RESEND_WAIT_IN_SEC);

const isCodeValid = computed(() => {
  return RegExp(/^[0-9]{6}$/).test(verificationCode.value);
});

const email = route.params.email;

const startDidntReceiveCounter = () => {
  let interval = setInterval(() => {
    --tryInSeconds.value;
    if (tryInSeconds.value == 0) clearInterval(interval);
  }, 1000);
};

const onNewEmailCodeSent = () => {
  tryInSeconds.value = MAX_RESEND_WAIT_IN_SEC;
  startDidntReceiveCounter();
};

const onVerifyCode = async () => {
  const userPlatform = await useGetUserPlatform();

  const request = await useHttpRequest<{
    success: string;
    message: string;
    temporaryToken: string;
    accessToken: string;
  }>({
    method: "POST",
    url: "staff/2fa/verify-email-code",
    loadingProperty: null,
    fullScreenLoaderMessage: "Verifying...",
    showFullScreenLoader: true,
    showSuccessMessage: true,
    body: {
      code: verificationCode.value,
      temporaryToken: route.params.temporaryToken,
      platform: userPlatform,
    },
  });
  if (!request) return;
  if (request.success && request.message == "Login Successful") {
    store.commit("LOGIN_USER", request);
    router.replace({ path: "/dashboard/home" });
  } else if (
    request.message == "Too much time has passed, please login again"
  ) {
    return router.replace("/login");
  }
};

const onDidntReceiveCode = async () => {
  if (tryInSeconds.value != 0) return;

  const request = await useHttpRequest<{ success: boolean; message: string }>({
    method: "POST",
    url: `staff/2fa/send-email`,
    loadingProperty: null,
    showFullScreenLoader: true,
    showSuccessMessage: true,
    body: {
      temporaryToken: route.params.temporaryToken,
    },
  });

  if (!request) return;
  if (request.success && request.message == "Email Code Sent") {
    onNewEmailCodeSent();
  } else if (
    request.message === "Too much time has passed, please login again"
  ) {
    //Go back to login screen
    return router.replace("/login");
  }
};

onMounted(() => {
  //If we have no temporaryToken in memory it means the user refreshed so we take them back to Login Screen
  if (!route.params.temporaryToken) {
    return router.replace({ name: "Login" });
  }
  startDidntReceiveCounter();

  // setUpFirebaseRECAPTCHA();
});

return { __sfc: true,MAX_RESEND_WAIT_IN_SEC, route, router, verificationCode, tryInSeconds, isCodeValid, email, startDidntReceiveCounter, onNewEmailCodeSent, onVerifyCode, onDidntReceiveCode }
}

})